import Playground from 'components/Playground';
import Pagination from "components/Pagination";
import * as React from 'react';
export default {
  Playground,
  Pagination,
  React
};